import {
  ArrowPathIcon,
  CheckIcon,
  ClockIcon,
  UserIcon,
} from "@heroicons/react/20/solid";
import logo from "./img/logo.png";
import logo_natur from "./img/naturcoop.png";
import logo_ba from "./img/brianzacque.png";

const eventTypes = {
  applied: { icon: UserIcon, bgColorClass: "bg-gray-400" },
  loading: { icon: ArrowPathIcon, bgColorClass: "bg-amber-500" },
  future: { icon: ClockIcon, bgColorClass: "bg-amber-500" },
  completed: { icon: CheckIcon, bgColorClass: "bg-green-500" },
};

const start = new Date();
start.setDate(start.getDate() - 42);

export default {
  nome: "Realizzazione sistemi di drenaggio urbano sostenibile lungo corso Roma – comune di Cesano Maderno",
  indirizzo: "Corso Roma/via Tommaseo Cesano Maderno",
  importo: "654 627.18",
  sicurezza: "37 206.15",
  impresa:
    "RTI Casalucci s.r.l. con CSEL Consorzio Società Cooperativa Sociale",
  dl: "Arch. Lorenzo Baldini",
  pm: "Dott. Luca Casalucci",
  cse: "Arch. Gaetano Giovanni Selleri",
  tecnico: "Geom. Michele Frontuto",
  progettista: "Pan Associati s.r.l.",
  inizio: "2025-08-25",
  durata: 151,
  descrizione:
    "L'appalto ha per oggetto l'esecuzione dell’intervento di retrofit e rigenerazione urbana mediante sistemi di drenaggio urbano sostenibile di corso Roma – comune di Cesano Maderno (MB).",
  cig: "B63A145EE2",
  cup: "G91J22000270002",
  committente: {
    nome: "BrianzAcquec s.r.l.",
    logo: logo_ba,
    indirizzo: "via Fermi 105, 20900 Monza (MB)",
    rup: "ing. Mauro Pozzi",
    telefono: "039262301",
    mail: "informazioni@brianzacque.it",
    pec: "brianzacque@legalmail.it",
  },
  esecutrici: [
    {
      nome: "Casalucci s.r.l.",
      logo: logo,
      legale: "via Processione 48, 21019 Somma Lombardo (VA)",
      operativa: "via Caregò 20, 21020 Crosio Della Valle (VA)",
      telefono: "0332 550295",
      mail: "mail@mail.it",
      pec: "pec@pec.it",
    },
    {
      nome: "Naturcoop Società Cooperativa Sociale",
      logo: logo_natur,
      legale: "Via Novara, 66/B 21019 Somma Lombardo (VA)",
      operativa: "Via Novara, 66/B 21019 Somma Lombardo (VA)",
      telefono: "0331 251717",
      mail: "alessandrorubin@naturcoop.it",
      pec: "pec@pec.naturcoop.it",
    },
  ],
  subappaltatori: [
    {
      sub: true,
      nome: "Edil Goseni s.r.l.s.",
      legale: "Via Don Tommaso Canestri, 8 15121 ALESSANDRIA (AL)",
      operativa: "Via Don Tommaso Canestri, 8 15121 ALESSANDRIA (AL)",
      telefono: "-",
      mail: "-",
      pec: "-",
      opere: "Realizzazione cordolatura in pietra",
    },
  ],
  fasi: [
    {
      id: 1,
      type: eventTypes.applied,
      content: "Inizio Lavori",
      datetime: start,
      date: "25 Ago",
    },
    {
      id: 2,
      type: eventTypes.completed,
      content: "via Tommaseo",
      datetime: "2025-09-05",
      date: "05 Set",
    },
    {
      id: 3,
      type: eventTypes.loading,
      content: "Da via Tommaseo a via Borromeo",
      datetime: "2025-10-02",
      date: "02 Ott",
    },
    {
      id: 4,
      type: eventTypes.future,
      content: "Da via Borromeo a via Matteotti",
      datetime: "2025-10-29",
      date: "29 Ott",
    },
    {
      id: 5,
      type: eventTypes.future,
      content: "Da via Matteotti a via L. Da Vinci",
      datetime: "2025-10-29",
      date: "25 Nov",
    },
    {
      id: 6,
      type: eventTypes.future,
      content: "Da via L. Da Vinci a via Cardinal Ferrari",
      datetime: "2025-12-22",
      date: "22 Dic",
    },
    {
      id: 7,
      type: eventTypes.future,
      content: "Da via Cardinal Ferrari a Corso della Libertà",
      datetime: "2026-01-18",
      date: "18 Gen",
    },
    {
      id: 8,
      type: eventTypes.future,
      content: "Asfaltatura e finitura",
      datetime: "2026-01-23",
      date: "23 Gen",
    },
  ],
  comunicazioni: [
    {
      id: 1,
      time: "25 AGO",
      datetime: "2025-08-25",
      content:
        "Si informa la cittadinanza che in data 25 agosto avranno inizio i lavori. Sarà pertanto interdetto il parcheggio e ristretta la carreggiata lungo via Tommaseo.",
      oggetto: "Inizio lavori",
    },
  ],
};
